import { get } from 'lodash-es';
import store from '../store';

export const request = (url: string, variables: any) => {
  const headers = {
    'Content-Type': 'application/json',
    'data-report-app-id': store.appId,
    ...(store.staffname ? {
      'data-report-staffname': store.staffname,
    } : {}),
  };
  return fetch(url, {
    method: 'POST',
    keepalive: true,
    headers,
    body: JSON.stringify(variables),
    credentials: 'include',
  })
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(new Error(response.statusText));
      }
      return response.json();
    })
    .then((response) => {
      const { data, errors } = response;

      if (errors && errors.length > 0) {
        const error = get(errors, '0.message');
        return Promise.reject(new Error(error));
      }

      return data;
    });
};
